import { render, staticRenderFns } from "./JobProgress.yaml?vue&type=template&id=2b89461a&component"
import script from "./JobProgress.yaml?vue&type=script&lang=ts&component"
export * from "./JobProgress.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports